/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  align-items: flex-start;
  background-color: var(--qds-theme-accessory-background);
  border-radius: var(--qds-accessory-border-radius);
  box-shadow: var(--qds-theme-accessory-elevation);
  box-sizing: border-box;
  color: var(--qds-theme-text-standard);
  display: flex;
  flex-direction: column;
  gap: var(--qds-accessory-gap-children-unrelated);
  left: 0;
  padding: var(--qds-accessory-padding);
  top: 0;
}

:host::before {
  content: '';
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

::slotted(blockquote),
::slotted(button),
::slotted(dd),
::slotted(dl),
::slotted(fieldset),
::slotted(figure),
::slotted(h1),
::slotted(h2),
::slotted(h3),
::slotted(h4),
::slotted(h5),
::slotted(h6),
::slotted(hr),
::slotted(input),
::slotted(menu),
::slotted(ol),
::slotted(p),
::slotted(pre),
::slotted(select),
::slotted(textarea),
::slotted(ul) {
  margin: 0;
}

:host([data-side='top'])::before,
:host([data-side='bottom'])::before {
  height: calc(
    var(--qds-accessory-gap-floating, 0px) +
      var(--qds-signature-triangle-pointer-size-height, 0px)
  );
  top: 100%;
}

:host([data-side='bottom'])::before {
  top: calc(
    -1 * (var(--qds-accessory-gap-floating, 0px) +
          var(--qds-signature-triangle-pointer-size-height, 0px))
  );
}

:host([data-side='left'])::before,
:host([data-side='right'])::before {
  width: calc(
    var(--qds-accessory-gap-floating, 0px) +
      var(--qds-signature-triangle-pointer-size-height, 0px)
  );
  left: 100%;
}

:host([data-side='right'])::before {
  left: calc(
    -1 * (var(--qds-accessory-gap-floating, 0px) +
          var(--qds-signature-triangle-pointer-size-height, 0px))
  );
}

.qds-arrow-container {
  height: var(--qds-signature-triangle-pointer-size-width);
  position: absolute;
  width: var(--qds-signature-triangle-pointer-size-width);

  &[data-side='bottom'] {
    bottom: 100%;
    transform: rotate(180deg);
  }

  &[data-side='left'] {
    left: 100%;
    transform: rotate(-90deg);
  }

  &[data-side='right'] {
    right: 100%;
    transform: rotate(90deg);
  }

  &[data-side='top'] {
    top: 100%;
  }
}

.qds-arrow {
  fill: var(--qds-theme-accessory-background);
}
